import { c as _c } from "react/compiler-runtime";
import { AnimatePresence, motion } from 'framer-motion';
import { useTranslations } from 'next-intl';
import { useSearchParams } from 'next/navigation';
import { useEffect, useRef, useState } from 'react';
import ArrowLeftIcon from '@/components/assets/icon_arrow_left.svg';
import SearchInputField from '@/components/SearchInputField';
import { SEARCH_PARAM_KEYS } from '@/constants/search';
import { useWorldSearchContext } from '@/context/WorldSearchContext';
import { cn } from '@/lib/utils';
import IconTool from '@/public/images/worlds/icon_tool.svg';
type MobileSearchInputProps = {
  showFilters?: boolean;
  hiddenFilters?: boolean;
  onSearchValueChange?: (value: string) => void;
  onSearchComplete?: () => void;
  onShowFiltersChange?: (show: boolean) => void;
};
export default function MobileSearchInput(t0) {
  const $ = _c(34);
  const {
    showFilters: t1,
    hiddenFilters: t2,
    onSearchValueChange,
    onSearchComplete,
    onShowFiltersChange
  } = t0;
  const showFilters = t1 === undefined ? false : t1;
  const hiddenFilters = t2 === undefined ? false : t2;
  const t = useTranslations();
  const searchInputRef = useRef(null);
  const searchParams = useSearchParams();
  let t3;
  if ($[0] !== searchParams) {
    t3 = searchParams.get(SEARCH_PARAM_KEYS.KEYWORD) || "";
    $[0] = searchParams;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const keyword = t3;
  const {
    startSearch,
    searchValue: initialValue
  } = useWorldSearchContext();
  const [searchValue, setSearchValue] = useState(initialValue);
  const [isSearchAnimating, setIsSearchAnimating] = useState(false);
  let t4;
  let t5;
  if ($[2] !== keyword) {
    t4 = () => {
      setSearchValue(keyword);
    };
    t5 = [keyword];
    $[2] = keyword;
    $[3] = t4;
    $[4] = t5;
  } else {
    t4 = $[3];
    t5 = $[4];
  }
  useEffect(t4, t5);
  let t6;
  if ($[5] !== onSearchComplete || $[6] !== searchValue || $[7] !== startSearch) {
    t6 = () => {
      setIsSearchAnimating(true);
      startSearch(searchValue, {
        onAfterNavigate: () => {
          setIsSearchAnimating(false);
          onSearchComplete?.();
        }
      });
    };
    $[5] = onSearchComplete;
    $[6] = searchValue;
    $[7] = startSearch;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  const handleSearch = t6;
  let t7;
  if ($[9] !== onSearchValueChange) {
    t7 = value => {
      setSearchValue(value);
      onSearchValueChange?.(value);
    };
    $[9] = onSearchValueChange;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  const handleSearchValueChange = t7;
  let t8;
  if ($[11] !== onSearchValueChange) {
    t8 = () => {
      setSearchValue("");
      onSearchValueChange?.("");
      if (searchInputRef?.current) {
        searchInputRef.current.focus();
      }
    };
    $[11] = onSearchValueChange;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  const handleClearSearch = t8;
  let t9;
  if ($[13] !== handleClearSearch || $[14] !== searchValue) {
    t9 = searchValue && <ArrowLeftIcon className="stroke-vive-primary-20 my-auto size-5 w-auto cursor-pointer" onClick={handleClearSearch} />;
    $[13] = handleClearSearch;
    $[14] = searchValue;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== t) {
    t10 = t("worlds-landing.search.placeholder");
    $[16] = t;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== handleClearSearch || $[19] !== handleSearch || $[20] !== handleSearchValueChange || $[21] !== isSearchAnimating || $[22] !== searchValue || $[23] !== t10) {
    t11 = <SearchInputField ref={searchInputRef} value={searchValue} placeholder={t10} isAnimating={isSearchAnimating} onValueChange={handleSearchValueChange} onSearch={handleSearch} onClear={handleClearSearch} autoFocus={true} />;
    $[18] = handleClearSearch;
    $[19] = handleSearch;
    $[20] = handleSearchValueChange;
    $[21] = isSearchAnimating;
    $[22] = searchValue;
    $[23] = t10;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== hiddenFilters || $[26] !== onShowFiltersChange || $[27] !== searchValue || $[28] !== showFilters) {
    t12 = !hiddenFilters && <AnimatePresence>{searchValue && <motion.div initial={{
        opacity: 0,
        scale: 0.8
      }} animate={{
        opacity: 1,
        scale: 1
      }} exit={{
        opacity: 0,
        scale: 0.8
      }} transition={{
        duration: 0.2
      }} className={cn("grid size-[34px] cursor-pointer place-items-center rounded-full transition-colors", {
        "bg-vive-primary-70/60": showFilters
      })} onClick={() => onShowFiltersChange?.(!showFilters)}><IconTool className="stroke-vive-primary-20 my-auto size-auto p-1.5" /></motion.div>}</AnimatePresence>;
    $[25] = hiddenFilters;
    $[26] = onShowFiltersChange;
    $[27] = searchValue;
    $[28] = showFilters;
    $[29] = t12;
  } else {
    t12 = $[29];
  }
  let t13;
  if ($[30] !== t11 || $[31] !== t12 || $[32] !== t9) {
    t13 = <div className="flex items-center gap-2 px-4 py-3">{t9}{t11}{t12}</div>;
    $[30] = t11;
    $[31] = t12;
    $[32] = t9;
    $[33] = t13;
  } else {
    t13 = $[33];
  }
  return t13;
}